import React from 'react'

const Boxing = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 20 25' version='1.1'>
      <title>Boxing</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-737.000000, -731.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-19' transform='translate(693.000000, 707.000000)'>
            <g id='icon/16/sport/boxing/glove' transform='translate(41.000000, 24.089286)'>
              <path
                d='M20.25,21.375 L20.25,24 L6,24 L6,21.375 L20.25,21.375 Z M20.25,2.39808173e-14 C21.4926407,2.39808173e-14 22.5,1.00735931 22.5,2.25 L22.5,12 C22.5,12.0569485 22.4968264,12.1131559 22.4906465,12.1684547 C22.4968369,12.2364738 22.5,12.3053675 22.5,12.375 L22.5,17.25 C22.5,18.4926407 21.4926407,19.5 20.25,19.5 L5.25,19.5 C4.00735931,19.5 3,18.4926407 3,17.25 L3,12.375 C3,11.1323593 4.00735931,10.125 5.25,10.125 L7.5,10.125 L7.5,10.1325 L10.125,10.1325 C11.4711941,10.1325 12.5625,11.2238059 12.5625,12.57 C12.5625,13.9161941 11.4711941,15.0075 10.125,15.0075 L9,15.0075 L9,16.8825 L10.125,16.8825 C12.506728,16.8825 14.4375,14.951728 14.4375,12.57 C14.4375,11.6732036 14.1637624,10.840342 13.6952847,10.1504126 L15.8786797,10.1504126 C17.4855787,10.1504126 19.0266634,9.51207444 20.1629126,8.37582521 L18.8370874,7.05 C18.0524689,7.83461852 16.9882978,8.27541261 15.8786797,8.27541261 L15,8.27541261 L15,8.25 L6.75,8.25 C5.50735931,8.25 4.5,7.24264069 4.5,6 L4.5,2.25 C4.5,1.00735931 5.50735931,2.39808173e-14 6.75,2.39808173e-14 L20.25,2.39808173e-14 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Boxing
